import { render, staticRenderFns } from "./VueCanvas.vue?vue&type=template&id=0e10bf42"
import script from "./VueCanvas.vue?vue&type=script&lang=js"
export * from "./VueCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports